import React, { useRef } from 'react';

import { CAMADAS } from '../../../styles/camadas';
import { styledDs as styled } from '../../../styles/theme';
import { DsButton } from '../Button';
import { DsModal } from '../Modal';

export type DsConfirmModalProps = {
  open: boolean;
  title: string;
  description?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

const Painel = styled.div`
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.lg};
  box-shadow: ${({ theme }) => theme.shadow.card};
  padding: ${({ theme }) => theme.space.xl};

  h2 {
    font-size: ${({ theme }) => theme.font.sizeLg};
    font-weight: ${({ theme }) => theme.weight.semibold};
    color: ${({ theme }) => theme.colors.textPrimary};
    margin-bottom: ${({ theme }) => theme.space.xs};
  }

  p {
    font-size: ${({ theme }) => theme.font.sizeMd};
    line-height: 1.45;
    color: ${({ theme }) => theme.colors.textSecondary};
  }
`;

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.space.sm};
  margin-top: ${({ theme }) => theme.space.xl};
`;

let sequencia = 0;

export const DsConfirmModal: React.FC<DsConfirmModalProps> = ({
  open,
  title,
  description,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  danger = false,
  onConfirm,
  onCancel,
}) => {
  // id próprio por instância: dois diálogos abertos com o mesmo `id` fazem o
  // leitor de tela anunciar o título errado.
  const idTitulo = useRef(`ds-confirm-title-${(sequencia += 1)}`).current;

  return (
    <DsModal open={open} onClose={onCancel} labelledBy={idTitulo} camada={CAMADAS.confirmacao}>
      <Painel>
        <h2 id={idTitulo}>{title}</h2>
        {description && <p>{description}</p>}
        <Actions>
          <DsButton variant="secondary" onClick={onCancel}>
            {cancelLabel}
          </DsButton>
          <DsButton variant={danger ? 'danger' : 'primary'} onClick={onConfirm}>
            {confirmLabel}
          </DsButton>
        </Actions>
      </Painel>
    </DsModal>
  );
};
